'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _parseCssFont2 = require('parse-css-font');

var _parseCssFont3 = _interopRequireDefault(_parseCssFont2);

var _WixStylesFontFamilies = require('./WixStylesFontFamilies');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WixFontUtils = {
    parseFontFamilies: function parseFontFamilies(_ref) {
        var fonts = _ref.fonts;

        var result = _lodash2.default.cloneDeep(fonts);

        _lodash2.default.each(fonts, function (font, key) {
            var split = font.value.split(' ');
            var fontFamily = (0, _WixStylesFontFamilies.getFontFamilyWithFallbacks)(split[4]);

            result[key].value = split.slice(0, 4).join(' ') + ' ' + fontFamily;
        });

        return result;
    },
    getFullFontStyles: function getFullFontStyles(_ref2) {
        var _this = this;

        var fontStyles = _ref2.fontStyles,
            siteTextPresets = _ref2.siteTextPresets,
            defaults = _ref2.defaults,
            isHebrew = _ref2.isHebrew,
            _ref2$forceArial = _ref2.forceArial,
            forceArial = _ref2$forceArial === undefined ? true : _ref2$forceArial;

        var ret = {};

        // Fix color styles due to '.' to '-' conversion
        var fixedFontStyles = {};
        _lodash2.default.each(fontStyles, function (v, k) {
            return fixedFontStyles[k.replace(/\./g, '-')] = v;
        });

        var parsedSiteTextPresets = {};
        _lodash2.default.each(siteTextPresets, function (preset, key) {
            if (preset.displayName) {
                parsedSiteTextPresets[key] = _lodash2.default.extend({}, parseCssFont(preset.value), { preset: key, editorKey: preset.editorKey, displayName: preset.displayName });
            } else {
                parsedSiteTextPresets[key] = _lodash2.default.extend({}, parseCssFont(preset.value), { preset: key, editorKey: preset.editorKey });
            }
        });

        var parsedFontStyles = {};
        _lodash2.default.each(fixedFontStyles, function (value, key) {
            return parsedFontStyles[key] = parseWixStylesFont(value);
        });

        // Basic template colors
        _lodash2.default.each(parsedSiteTextPresets, function (preset, key) {
            return ret[key] = parsedFontStyles[key] || preset;
        });

        // LIGHT/MEDIUM/STRONG
        if (isHebrew) {
            ret['LIGHT'] = ret['MEDIUM'] = ret['STRONG'] = parseCssFont('12px Arial');
        } else {
            ret['LIGHT'] = parseCssFont('12px HelveticaNeueW01-45Ligh');
            ret['MEDIUM'] = parseCssFont('12px HelveticaNeueW01-55Roma');
            ret['STRONG'] = parseCssFont('12px HelveticaNeueW01-65Medi');
        }

        _lodash2.default.each(_lodash2.default.toPairs(defaults), function (_ref3) {
            var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
                key = _ref4[0],
                value = _ref4[1];

            ret[key] = parsedFontStyles[key] || _this.calcValueFromString({ str: value, values: ret });
        });

        _lodash2.default.each(ret, function (font, key) {
            if (isHebrew && forceArial) {
                font = JSON.parse((0, _stringify2.default)(font));
                font.family = ['Arial'];
            }

            ret[key] = _lodash2.default.extend({}, font, { supports: { uppercase: true } });

            if (_lodash2.default.find(font.family, function (f) {
                return _lodash2.default.includes(f, 'snellroundhandw');
            }) || _lodash2.default.find(font.family, function (f) {
                return _lodash2.default.includes(f, 'niconne');
            })) {
                ret[key].supports.uppercase = false;
            }

            if (ret[key].size === 'normal') {
                ret[key].size = '1em';
            }

            if (ret[key].lineHeight === 'normal') {
                ret[key].lineHeight = '1.5em'; // Wix's normal line height is 1.5em...
            }

            _lodash2.default.each(font.family, function (f, ind) {
                return font.family[ind] = f.replace(/\s*;\s*$/, '');
            });
        });

        return ret;
    },
    fontToUiLibStructure: function fontToUiLibStructure(font) {
        return {
            size: parseInt(font.size),
            style: {},
            family: font.family.join(','),
            preset: font.preset,
            editorKey: font.editorKey,
            displayName: font.displayName
        };
    },
    toFontCssValue: function toFontCssValue(font) {
        var size = _lodash2.default.isNumber(font.size) ? font.size + 'px' : font.size;
        var lineHeight = _lodash2.default.isNumber(font.lineHeight) ? font.lineHeight + 'px' : font.lineHeight;
        var family = font.family;

        if (family.length === 1) {
            family[0] = (0, _WixStylesFontFamilies.getFontFamilyWithFallbacks)(family[0]);
        }

        var cssValue = font.style + ' ' + font.variant + ' ' + font.weight + ' ' + size + '/' + lineHeight + ' ' + font.family.join(',');

        return cssValue;
    },
    calcValueFromString: function calcValueFromString(_ref5) {
        var str = _ref5.str,
            values = _ref5.values;


        var preset = function preset(_default) {
            return values[_default];
        };
        var font = function font(_default) {
            return _lodash2.default.extend({}, values[_default.template], _lodash2.default.omit(_default, 'template'));
        };

        var m = null;

        if (m = str.match(/preset\((.*)\)$/)) {
            return preset(m[1].trim());
        } else if (m = str.match(/font\((.*)\)$/)) {
            return font(JSON.parse(m[1].trim().replace(/'/g, '"')));
        } else if (values[str]) {
            return values[str];
        } else if (str.startsWith('font-') && values[str.substr(5)]) {
            return values[str.substr(5)];
        } else {
            throw new Error('Unknown font default ' + str);
        }
    }
};

function parseWixStylesFont(font) {
    var value = '';

    if ((font.style || {}).italic) {
        value = 'italic ';
    }

    if ((font.style || {}).bold) {
        value += 'bold ';
    }

    var size = font.size || 'normal';
    if (isUnitlessNumericValue(size)) size = size + 'px';
    var lineHeight = font.lineHeight || 'normal';
    if (_lodash2.default.isNumber(lineHeight)) lineHeight = lineHeight + 'px';

    value += size + '/' + lineHeight + ' ';

    value += font.cssFontFamily || font.family;

    return parseCssFont(value);
}

function isUnitlessNumericValue(size) {
    // If the value is a number, or a string representation of a number
    return _lodash2.default.isNumber(size) || parseInt(size, 10) == size;
}

function parseCssFont(font) {
    return _lodash2.default.cloneDeep((0, _parseCssFont3.default)(font));
}

exports.default = WixFontUtils;